<template lang="html">
  <router-view/>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'revision',
  computed: {
    ...mapGetters({
      'unit': 'unit/get',
      'topics': 'topic/getAll'
    })
  },
  async beforeCreate () {
    await this.$store.dispatch('unit/setUnit')
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/revision/index.vue